'use client';


import AssetsManagement from '@/app/assets/components/AssetsManagement';

export default function AssetsPage() {
  return (

    <AssetsManagement />

  );
}
